<script>
import { vueBaberrage, MESSAGE_TYPE } from 'vue-baberrage';

export default {
  name: 'Barrage',
  components: {
    vueBaberrage
  },
  props: {
    pause: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localBarrageList: [],
      danmuId: 0
    };
  },
  methods: {
    getMessage(msgs) {
      if (!msgs || !msgs.length) return;
      this.messageHandle(msgs);
    },
    messageHandle(data) {
      let danmu = [];

      for (let i = 0; i < data.length; i++) {
        const d = data[i];
        let msg = '';
        if (d.payload && d.payload.text) {
          msg = JSON.parse(d.payload.text).text;
        } else if (d.text) {
          msg = d.text;
        }
        msg &&
          danmu.push({
            id: ++this.danmuId + '_d',
            msg,
            time: 5,
            type: MESSAGE_TYPE.NORMAL
          });
      }
      // console.log(danmu);
      danmu.length && this.send(danmu);
    },
    log(val) {
      console.log(val);
    },
    clear() {
      this.localBarrageList = [];
    },
    send(val) {
      //   {
      //     id: 1,
      //     avatar: './static/avatar.jpg',
      //     msg: this.msg,
      //     data: {
      //       userName: 'more data'
      //     },
      //     time: 5,
      //     extraWidth: 60
      //   }
      this.localBarrageList.push(...val);
    },
    renderMsg(props) {
      return props ? props.item.msg : '';
    },
    barrageListEmpty() {
      this.localBarrageList = [];
      this.$emit('barrageListEmpty');
    }
  },
  watch: {
    pause() {
      this.pause ? this.$refs.baberrage.pause() : this.$refs.baberrage.play();
    }
  },
  computed: {
    baberrage() {
      return this.$refs.baberrage;
    }
  },
  render() {
    const props = {
      props: {
        lanesCount: 2,
        isShow: this.show,
        throttleGap: 3500,
        boxHeight: 150,
        barrageList: this.localBarrageList,
        maxWordCount: 3,
        messageHeight: 24,
        loop: this.loop
      },
      scopedSlots: {
        default: (props) => {
          return (
            <div class={{ 'baberrage-item-box': !!props.item.msg }} style={{ color: 'white' }}>
              {this.renderMsg(props)}
            </div>
          );
        }
      }
    };
    return (
      <vue-baberrage
        class="baberrage-wrap"
        v-show={this.show}
        ref="baberrage"
        {...{ on: { 'barrage-list-empty': this.barrageListEmpty } }}
        {...props}
      ></vue-baberrage>
    );
  }
};
</script>
<style lang="less" scoped>
.baberrage-wrap {
  font-size: 16px;
  width: 100%;
}
</style>
